import { createSlice } from '@reduxjs/toolkit'

export type ReportsState = {
  reports: {
    id: number
    name: string
    description: string
    requireStatement: boolean
  }[]
  scheduledReports: []
}

const initialState: ReportsState = {
  reports: [],
  scheduledReports: [],
}

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setReports: (state, action) => {
      state.reports = action.payload
    },
    setScheduledReports: (state, action) => {
      state.scheduledReports = action.payload
    },
  },
})

export const { setReports, setScheduledReports } = reportsSlice.actions
export default reportsSlice.reducer
